import React, { Component } from 'react';
import '../../../App.css';
import '../../../styles/app-demo.css';

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const currentDate = new Date();
const currentMonth = monthNames[currentDate.getMonth()];

class MonthlyTransactions extends Component {

  constructor(props){
    super(props)
    this.toggleNewRoute = this.toggleNewRoute.bind(this);
  }

  toggleNewRoute() {
    this.props.toggleNewRoute('transactions')
  }

  render() {

    return (
      <section className="monthly-transactions-section">
        <div id="month-container">
          <i className="fa fa-angle-left"></i>
          <p>{currentMonth}</p>
        </div>
        <div id="monthly-transactions-categories-wrapper">
          <ul>
            <li>
              <p>Automotive - 13%</p>
              <p>-$21.00</p>
            </li>
            <li>
              <p>Retail Stores - 10%</p>
              <p>-$15.00</p>
            </li>
            <li>
              <p>Travel - 8%</p>
              <p>-$13.00</p>
            </li>
            <li>
              <p>Financial - 11%</p>
              <p>-$17.00</p>
            </li>
            <li>
              <p>Utilities - 15%</p>
              <p>-$23.00</p>
            </li>
          </ul>
        </div>
        <button onClick={this.toggleNewRoute}>View All Transactions</button>
      </section>
    );
  }
}

export default MonthlyTransactions;
